import { render, staticRenderFns } from "./IconSwitchVerticalOutline.vue?vue&type=template&id=ea7c34e2"
import script from "./IconSwitchVerticalOutline.vue?vue&type=script&lang=js"
export * from "./IconSwitchVerticalOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports